import React, { Component } from "react";
import axios from "axios";
import Constants from "Helpers/Constants";
import init from "Helpers/WindowToken";

import DataTable from "examples/Tables/DataTable";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import { Card, Grid } from "@mui/material";
import { Link, Navigate } from "react-router-dom";

import MDBox from "components/MDBox";
import MDSnackbar from "components/MDSnackbar";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

export default class CareerCategories extends Component {
  state = {
    allJobs: [],
    message: "",
    notification: false,
    noticolor: "success",
    redirect: false,
  };

  componentDidMount() {
    this.getAllLevels();
  }

  getAllLevels = () => {
    if (init() !== "success") {
      this.setState({ redirect: true });
      return;
    }

    axios
      .get(Constants.getUrls.getAllCareerCategories)
      .then((resp) => {
        if (resp.data.status === "success") {
          this.setState({
            allJobs: resp.data?.data || [], // ✅ ALWAYS array
          });
        } else {
          this.showSnackbar("error", resp.data.message);
        }
      })
      .catch(() => {
        this.showSnackbar("error", "Failed to fetch blog categories");
      });
  };

  handleDelete = (id) => {
    if (init() !== "success") return;

    axios
      .delete(Constants.deleteUrls.deleteCareerCategory + id)
      .then((resp) => {
        if (resp.data.status === "success") {
          this.showSnackbar("success", resp.data.message);
          this.getAllLevels(); // ✅ FIXED
        }
      })
      .catch(() => {
        this.showSnackbar("error", "Delete failed");
      });
  };

  showSnackbar = (color, message) => {
    this.setState({
      notification: true,
      noticolor: color,
      message,
    });

    setTimeout(() => {
      this.setState({ notification: false, message: "" });
    }, 2500);
  };

  render() {
    if (this.state.redirect) {
      return <Navigate to="/signin" replace />;
    }

    return (
      <DashboardLayout>
        <DashboardNavbar />

        <MDBox pt={6} pb={3}>
          <Card>
            {/* HEADER */}
            <MDBox
              mx={2}
              mt={-3}
              py={3}
              px={2}
              variant="gradient"
              bgColor="info"
              borderRadius="lg"
              coloredShadow="info"
            >
              <MDTypography variant="h6" color="white">
                Career Categories
              </MDTypography>
            </MDBox>

            {/* CREATE BUTTON */}
            <Grid item sm={4} px={2} align="right">
              <Link to="/addCareerCategory">
                <MDButton variant="contained" size="small" color="primary">
                  Create
                </MDButton>
              </Link>
            </Grid>

            {/* TABLE / EMPTY STATE */}
            <MDBox>
              {this.state.allJobs.length > 0 ? (
                <DataTable
                  table={{
                    columns: [
                      { Header: "Serial", accessor: "serial", width: "6%" },
                      { Header: "Category", accessor: "name" },
                      { Header: "Action", accessor: "action" },
                    ],
                    rows: this.state.allJobs.map((job, index) => ({
                      serial: index + 1,
                      name: job.category_name || "-",
                      action: (
                        <>
                          <div>
                            <Link
                              to={{
                                pathname: "/updateCareerCategory/" + job._id,
                                state: { data: job },
                              }}
                            >
                              <MDButton
                                variant="outlined"
                                size="small"
                                color="success"
                              >
                                Update
                              </MDButton>
                            </Link>
                          </div>

                          <div style={{ marginTop: "1rem" }}>
                            <MDButton
                              variant="outlined"
                              size="small"
                              color="error"
                              onClick={() => this.handleDelete(job._id)}
                            >
                              Delete
                            </MDButton>
                          </div>
                        </>
                      ),
                    })),
                  }}
                />
              ) : (
                <MDBox py={6} textAlign="center">
                  <MDTypography variant="body2" color="text">
                    No blog categories found.
                  </MDTypography>
                </MDBox>
              )}
            </MDBox>

            {/* SNACKBAR */}
            <MDSnackbar
              color={this.state.noticolor}
              icon="notifications"
              title="Asa-Agrotech"
              content={this.state.message}
              dateTime="Just now"
              open={this.state.notification}
            />
          </Card>
        </MDBox>
      </DashboardLayout>
    );
  }
}
